import { Box, Container, Grid, Link, Stack, Typography } from "@mui/material";

const LINK_COLUMNS: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "#features" },
      { label: "Pricing", href: "#pricing" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Contact", href: "mailto:info@tekstartechnologies.com" },
    ],
  },
];

export function LandingFooter() {
  return (
    <Box component="footer" sx={{ bgcolor: "#0F172A", color: "#94A3B8", pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} mb={6}>
          <Grid item xs={12} md={5}>
            <Typography variant="h6" fontWeight={800} color="#fff" mb={1.5}>
              TekStar Invest
            </Typography>
            <Typography variant="body2" mb={2} maxWidth={340}>
              AI-powered investment intelligence and algorithmic trading — connected securely to
              your existing broker.
            </Typography>
            <Typography variant="body2">TekStar Technologies Pvt Ltd</Typography>
            <Typography variant="body2">Noida, India</Typography>
          </Grid>

          {LINK_COLUMNS.map((column) => (
            <Grid item xs={6} md={3} key={column.title}>
              <Typography variant="subtitle2" fontWeight={700} color="#fff" mb={2}>
                {column.title}
              </Typography>
              <Stack spacing={1.25}>
                {column.links.map((link) => (
                  <Link key={link.label} href={link.href} underline="hover" sx={{ color: "#94A3B8", "&:hover": { color: "#fff" } }}>
                    {link.label}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}

          <Grid item xs={6} md={3}>
            <Typography variant="subtitle2" fontWeight={700} color="#fff" mb={2}>
              Legal
            </Typography>
            <Stack spacing={1.25}>
              <Typography variant="body2" sx={{ color: "#64748B" }}>
                Privacy Policy (coming soon)
              </Typography>
              <Typography variant="body2" sx={{ color: "#64748B" }}>
                Terms (coming soon)
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: "1px solid #1E293B", pt: 3 }}>
          <Typography variant="caption" sx={{ color: "#64748B" }}>
            © {new Date().getFullYear()} TekStar Technologies Pvt Ltd. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default LandingFooter;
